'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  Object.defineProperty(subClass, "prototype", {
    value: Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    }),
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

(function (ACTION) {
  ACTION["MESSAGE"] = "message";
  ACTION["MESSAGE_CLOSE"] = "messageclose";
  ACTION["OPEN_MODAL"] = "openModal";
  ACTION["MODAL_SAVE"] = "modalsave";
  ACTION["MODAL_CLOSE"] = "modalclose";
  ACTION["REDIRECT"] = "redirect";
  ACTION["GET_STORE_DATA"] = "getStoreData";
  ACTION["ROUTER_REDIRECT"] = "outerRedirect";
  ACTION["ROUTER_TO_SPECIFIED_PAGE"] = "specifiedpage";
})(exports.ACTION || (exports.ACTION = {}));

(function (ADMIN_SECTION) {
  ADMIN_SECTION["SALES"] = "sales";
  ADMIN_SECTION["OAUTH"] = "oauth";
  ADMIN_SECTION["ORDERS"] = "orders";
  ADMIN_SECTION["PRODUCTS"] = "products";
  ADMIN_SECTION["CUSTOMER"] = "customer";
  ADMIN_SECTION["CATEGORIES"] = "categories";
  ADMIN_SECTION["PACKAGEPURCHASE"] = "packagepurchase";
})(exports.ADMIN_SECTION || (exports.ADMIN_SECTION = {}));

var BridgeBasic = /*#__PURE__*/_createClass(function BridgeBasic() {
  _classCallCheck(this, BridgeBasic);

  this.dispatch = void 0;
  this.subscribe = void 0;
  this.unsubscribe = void 0;
});

var ACTION;

(function (ACTION) {
  ACTION["REDIRECT"] = "redirect";
  ACTION["ROUTER_REDIRECT"] = "routerRedirect";
  ACTION["ROUTER_TO_SPECIFIED_PAGE"] = "specifiedpage";
})(ACTION || (ACTION = {}));

var Redirect = /*#__PURE__*/function (_BridgeBasic) {
  _inherits(Redirect, _BridgeBasic);

  var _super = _createSuper(Redirect);

  function Redirect(app) {
    var _this;

    _classCallCheck(this, Redirect);

    _this = _super.call(this); // TODO初始化校验

    _this.localOrigin = void 0;

    _this.replaceTo = function (url) {
      _this.dispatch(ACTION.REDIRECT, {
        payLoad: {
          redirectUrl: url
        }
      });
    };

    _this.routerTo = function (url) {
      _this.dispatch(ACTION.ROUTER_REDIRECT, {
        payLoad: {
          redirectUrl: url
        }
      });
    };

    _this.navigate = function (params) {
      _this.dispatch(ACTION.REDIRECT, {
        payLoad: _objectSpread2({}, params)
      });
    };

    _this.ToAdminPage = function (section, params) {
      var payLoad = _objectSpread2({
        section: section
      }, params);

      if (!(section.toUpperCase() in exports.ADMIN_SECTION)) {
        console.error("[appbridge] ACTION execution failed. Please check whether your parameters[ADMIN_SECTION] are incorrect. ");
        return;
      }

      _this.dispatch(ACTION.ROUTER_TO_SPECIFIED_PAGE, {
        payLoad: payLoad
      });
    };

    _this.dispatch = app.dispatch;
    _this.subscribe = app.subscribe;
    _this.unsubscribe = app.unsubscribe;
    _this.localOrigin = app.localOrigin;
    return _this;
  }
  /**
   *
   * @param url
   */


  return _createClass(Redirect);
}(BridgeBasic);

function create(app) {
  return new Redirect(app);
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ACTION () { return ACTION; },
  create: create,
  Redirect: Redirect,
  get ADMIN_SECTION () { return exports.ADMIN_SECTION; }
});

function getLocation() {
  return hasWindow() ? window.location : undefined;
}

function getWindow() {
  return hasWindow() ? window : undefined;
}

function hasWindow() {
  return typeof window !== 'undefined';
}

var windowFk = {
  getLocation: getLocation,
  getWindow: getWindow
};

var subscribeFnMap = new Map();
/**
 * Cache callback function
 * @param key map key
 * @param fn callback function
 * @returns
 */

var pushSubscribeFn = function pushSubscribeFn(key, fn) {
  if (subscribeFnMap.get(key)) {
    var callBackFnArray = subscribeFnMap.get(key);
    callBackFnArray.push(fn);
    return;
  }

  subscribeFnMap.set(key, [fn]);
};
/**
 * Excution cache function
 * @param key map key
 * @returns
 */

var popSubscribeFn = function popSubscribeFn(key, type, e) {
  // 不存在订阅
  var callBackFnArray = subscribeFnMap.get(key);

  if (!(callBackFnArray === null || callBackFnArray === void 0 ? void 0 : callBackFnArray.length)) {
    return;
  }

  if (type === 'remove') {
    while (callBackFnArray === null || callBackFnArray === void 0 ? void 0 : callBackFnArray.length) {
      callBackFnArray.pop();
    }

    return;
  } // 消息来源一致性


  if (e.origin === windowFk.getWindow().origin) {
    return;
  } // 执行回调


  while (callBackFnArray === null || callBackFnArray === void 0 ? void 0 : callBackFnArray.length) {
    callBackFnArray.pop()();
  }
};

var loactionSearch;
var getHost = function getHost() {
  if (document.referrer) {
    return new URL(document.referrer).host;
  }

  if (!loactionSearch) {
    loactionSearch = windowFk.getLocation().search || windowFk.getLocation().hash;
  }

  var param = getUrlParams(loactionSearch);

  if (!param['handle']) {
    throw new Error('Cannot find [handle]. Initialization failed. Make sure sdk is used under appstore.！');
  }

  return "".concat(param['handle'], ".myshopline.com");
};

var getUrlParams = function getUrlParams(search) {
  if (!search) {
    throw new Error('url is undifined!');
  }

  var urlStr = search.split('?')[1];
  var urlSearchParams = new URLSearchParams(urlStr);
  var result = Object.fromEntries(urlSearchParams.entries());
  return result;
};

var share = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getHost: getHost
});

var fromWindow = function fromWindow(contentWindow, config) {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === undefined) {
    throw new Error("[appbridge] Please make sure that SDK is used in embedded application.! ");
  }

  var host = config.host,
      debug = config.debug;
  if (!host) host = getHost();
  var messageOrigin;
  var http = 'https';

  if (debug) {
    http = 'http';
  }

  try {
    if (debug) {
      console.log("[appbridge] connect host: ".concat("".concat(http, "://").concat(host)));
    }

    messageOrigin = new URL("".concat(http, "://").concat(host)).origin;
  } catch (error) {
    console.error("[appbridge] Client initialization failed. [Host] is missing. Please check whether you pass in the correct parameters.!");
  }

  return {
    localOrigin: host,
    hostFrame: contentWindow,
    dispatch: function dispatch(action, message) {
      var payLoad = message.payLoad;
      var postMsg = {
        action: action,
        payLoad: payLoad
      };
      contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow.postMessage(postMsg, messageOrigin);
      return postMsg;
    },
    subscribe: function subscribe(action, fn) {
      pushSubscribeFn(action, fn);
    },
    unsubscribe: function unsubscribe(action) {
      popSubscribeFn(action, 'remove');
    }
  };
}; // 监听通信消息


var initPostMessage = function initPostMessage() {
  console.log("[appbridge] Initialize communication......");
  window.addEventListener('message', function (e) {
    var _e$data = e.data,
        action = _e$data.action,
        done = _e$data.done;

    if (done) {
      popSubscribeFn(action, 'excute', e);
    }
  });
  console.log("[appbridge] Initialization communication complete...");
};

var messageTransport = {
  fromWindow: fromWindow,
  initPostMessage: initPostMessage
};

var createDispatcher = function createDispatcher(transport) {
  return function (action, message) {
    transport.dispatch(action, message);
  };
};

var createSubscription = function createSubscription(transport) {
  return function (action, fn) {
    transport.subscribe(action, fn);
  };
};

var createUnSubscription = function createUnSubscription(transport) {
  return function (action) {
    transport.unsubscribe(action);
  };
};

var createClientApp = function createClientApp(transport) {
  var dispatcher = createDispatcher(transport);
  var subscription = createSubscription(transport);
  var unsubscription = createUnSubscription(transport);
  return function () {
    return {
      localOrigin: transport.localOrigin,
      dispatch: function dispatch(action, message) {
        return dispatcher(action, message);
      },
      subscribe: function subscribe(action, fn) {
        return subscription(action, fn);
      },
      unsubscribe: function unsubscribe(action) {
        return unsubscription(action);
      }
    };
  };
};

var createAppWrapper = function createAppWrapper(frame, config) {
  var transport = messageTransport.fromWindow(frame, config);
  messageTransport.initPostMessage();
  var appCreator = createClientApp(transport);
  return appCreator;
};
/**
 * @param config appkey
 * @returns
 */


var createApp = function createApp(config) {
  // TODO.appkey校验
  var currentWindow = windowFk.getWindow();
  return createAppWrapper(currentWindow.parent, config)();
};

var Client = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createApp: createApp
});

var ACTION$1;

(function (ACTION) {
  ACTION["ROUTER_TO_SPECIFIED_PAGE"] = "specifiedpage";
})(ACTION$1 || (ACTION$1 = {}));

var Oauth = /*#__PURE__*/function (_BridgeBasic) {
  _inherits(Oauth, _BridgeBasic);

  var _super = _createSuper(Oauth);

  function Oauth(app) {
    var _this;

    _classCallCheck(this, Oauth);

    _this = _super.call(this);

    _this.invoke = function (config) {
      _this.dispatch(ACTION$1.ROUTER_TO_SPECIFIED_PAGE, {
        payLoad: {
          section: exports.ADMIN_SECTION.OAUTH,
          oauthInfo: _objectSpread2({}, config)
        }
      });
    };

    _this.dispatch = app.dispatch;
    return _this;
  }

  return _createClass(Oauth);
}(BridgeBasic);

function create$1(app) {
  return new Oauth(app);
}

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ACTION () { return ACTION$1; },
  create: create$1
});

var ACTION$2;

(function (ACTION) {
  ACTION["OPEN_MODAL"] = "openModal";
  ACTION["MODAL_SAVE"] = "modalsave";
  ACTION["MODAL_CLOSE"] = "modalclose";
})(ACTION$2 || (ACTION$2 = {}));

var Modal = /*#__PURE__*/function (_BridgeBasic) {
  _inherits(Modal, _BridgeBasic);

  var _super = _createSuper(Modal);

  function Modal(app) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this);

    _this.open = function (info) {
      var type = info.type,
          title = info.title,
          content = info.content;

      _this.dispatch(ACTION$2.OPEN_MODAL, {
        payLoad: {
          type: type,
          title: title,
          content: content
        }
      });
    };

    _this.dispatch = app.dispatch;
    _this.subscribe = app.subscribe;
    _this.unsubscribe = app.unsubscribe;
    return _this;
  }

  return _createClass(Modal);
}(BridgeBasic);

function create$2(app) {
  return new Modal(app);
}

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ACTION () { return ACTION$2; },
  create: create$2
});

var ACTION$3;

(function (ACTION) {
  ACTION["MESSAGE"] = "message";
  ACTION["MESSAGE_CLOSE"] = "messageclose";
})(ACTION$3 || (ACTION$3 = {}));

var Message = /*#__PURE__*/function (_BridgeBasic) {
  _inherits(Message, _BridgeBasic);

  var _super = _createSuper(Message);

  function Message(app) {
    var _this;

    _classCallCheck(this, Message);

    _this = _super.call(this);

    _this.open = function (info) {
      var type = info.type,
          messageInfo = info.messageInfo;

      _this.dispatch(ACTION$3.MESSAGE, {
        payLoad: {
          type: type,
          messageInfo: messageInfo
        }
      });
    };

    _this.dispatch = app.dispatch;
    _this.subscribe = app.subscribe;
    _this.unsubscribe = app.unsubscribe;
    return _this;
  }

  return _createClass(Message);
}(BridgeBasic);

function create$3(app) {
  return new Message(app);
}

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ACTION () { return ACTION$3; },
  create: create$3
});

var shareUtil = {
  getHost: getHost
};

exports.Message = index$3;
exports.Modal = index$2;
exports.Oauth = index$1;
exports.Redirect = index;
exports.default = Client;
exports.shareUtil = shareUtil;
exports.shared = share;
